<!--
 * @Author: weijinpeng jinpeng.wei@ctx.sg
 * @LastEditors: weijinpeng jinpeng.wei@ctx.sg
 * @Date: 2023-03-03 14:26:02
 * @LastEditTime: 2023-03-10 09:57:45
 * @Description: 
-->
<template>
    <div>
        <div class="tabs">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <!-- Account Management Log -->
                <el-tab-pane label="Account Management Log" name="1">
                    <!-- 搜索 -->
                    <div class="search">
                        <el-row type="flex" align="bottom" :gutter="20">
                            <el-col :span="7">
                                <div class="search_t">Action Time</div>
                                <el-date-picker
                                    v-model="fromData.date"
                                    style="width:100%"
                                    type="date"
                                    clearable
                                    placeholder="Action Time"
                                    format="yyyy/MM/dd"
                                    value-format="yyyy/MM/dd">
                                </el-date-picker>
                            </el-col>
                            <el-col :span="7">
                                <div class="search_t">Status</div>
                                <el-select v-model="fromData.status" style="width:100%" clearable placeholder="All">
                                    <el-option
                                    v-for="item in statusList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="7">
                                <div class="search_t">Operator</div>
                                <el-input v-model="fromData.operator" clearable placeholder="Operator"></el-input>
                            </el-col>
                            <el-col :span="3">
                                <div class="search_btn wd_90">Search</div>
                            </el-col>
                        </el-row>
                    </div>

                    <!-- 表格 -->
                    <div class="mg_t_50">
                      <el-table
                          :data="tableData.slice((currentPage - 1) * pageSize,currentPage * pageSize)"
                          stripe
                          :cell-style="columnStyle"
                          style="width: 100%"
                          :header-cell-style="{
                            background: '#F0F3F6',
                            color: '#626262',
                            fontSize: '12px',
                            paddingTop: '17px',
                            paddingBottom: '15px',
                          }"
                      >
                          <!-- 空状态 -->
                          <template slot="empty">
                            <p style="margin-top: 50px">
                              <img class="data-pic" src="../../assets/img/noData.png" alt=""/>
                            </p>
                            <p class="nodata">{{ $t("carbonIndex.noData") }}</p>
                          </template>
                          <el-table-column prop="operator" label="Operator"></el-table-column>
                          <el-table-column prop="actionTime" label="Action Time"></el-table-column>
                          <el-table-column prop="status" label="Status"></el-table-column>
                          <el-table-column prop="content" width="250" label="Content"></el-table-column>
                      </el-table>
                      <div class="display_flex" style="margin-top: 47px">
                          <el-pagination
                            v-if="tableData.length != 0"
                            @current-change="handleCurrentChange"
                            :page-size="pageSize"
                            background
                            layout="prev, pager, next"
                            class="pagination"
                            prev-text="<"
                            next-text=">"
                            :total="tableData.length"
                          >
                          </el-pagination>
                      </div>
                    </div>
                </el-tab-pane>

                <!-- ICC Management Log -->
                <el-tab-pane label="ICC Management Log" name="2">
                    <!-- 搜索 -->
                    <div class="search">
                        <el-row type="flex" align="bottom" :gutter="20">
                            <el-col :span="7">
                                <div class="search_t">Action Time</div>
                                <el-date-picker
                                    v-model="fromData.date"
                                    style="width:100%"
                                    type="date"
                                    clearable
                                    placeholder="Action Time"
                                    format="yyyy/MM/dd"
                                    value-format="yyyy/MM/dd">
                                </el-date-picker>
                            </el-col>
                            <el-col :span="7">
                                <div class="search_t">Status</div>
                                <el-select v-model="fromData.status" style="width:100%" clearable placeholder="All">
                                    <el-option
                                    v-for="item in statusList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="7">
                                <div class="search_t">Operator</div>
                                <el-input v-model="fromData.operator" clearable placeholder="Operator"></el-input>
                            </el-col>
                            <el-col :span="3">
                                <div class="search_btn wd_90">Search</div>
                            </el-col>
                        </el-row>
                    </div>

                    <!-- 表格 -->
                    <div class="mg_t_50">
                      <el-table
                          :data="tableData1.slice((currentPage - 1) * pageSize,currentPage * pageSize)"
                          stripe
                          :cell-style="columnStyle"
                          style="width: 100%"
                          :header-cell-style="{
                            background: '#F0F3F6',
                            color: '#626262',
                            fontSize: '12px',
                            paddingTop: '17px',
                            paddingBottom: '15px',
                          }"
                      >
                          <!-- 空状态 -->
                          <template slot="empty">
                            <p style="margin-top: 50px">
                              <img class="data-pic" src="../../assets/img/noData.png" alt=""/>
                            </p>
                            <p class="nodata">{{ $t("carbonIndex.noData") }}</p>
                          </template>
                          <el-table-column prop="operator" label="Operator"></el-table-column>
                          <el-table-column prop="actionTime" label="Action Time"></el-table-column>
                          <el-table-column prop="status" label="Status"></el-table-column>
                          <el-table-column prop="content" width="250" label="Content"></el-table-column>
                      </el-table>
                      <div class="display_flex" style="margin-top: 47px">
                          <el-pagination
                            v-if="tableData.length != 0"
                            @current-change="handleCurrentChange"
                            :page-size="pageSize"
                            background
                            layout="prev, pager, next"
                            class="pagination"
                            prev-text="<"
                            next-text=">"
                            :total="tableData1.length"
                          >
                          </el-pagination>
                      </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
  </template>
  
  <script>
   
  export default {
    name: 'systemlog',
    components: {
    },
    data(){
      return {
        activeName: '1',
        fromData:{
          date:"",
          status:"",
          operator:"",
        },
        statusList:[
            {
                value: '1',
                label: 'Failure'
            },
            {
                value: '2',
                label: 'Success'
            },
        ],
        tableData:[
            {
                operator:'23456',
                actionTime:'2022/12/12 23:00:00',
                status:'Failure',
                content:'Ellen Create a New User kaixin'
            }
        ],
        tableData1:[
            {
                operator:'23654',
                actionTime:'2022/12/12 23:00:00',
                status:'Failure',
                content:"Ketty approve Larin's retirement request"
            }
        ],
        pageSize: 10,
        currentPage: 1,
      }
    },
    mounted(){},
    methods:{
      handleClick(tab, event) {
        console.log(tab, event);
      },
      columnStyle({ row, column, rowIndex, columnIndex}){
          if(columnIndex == 1){
              return "color:#366F67;word-break:break-word;";
          }
          return "word-break:break-word;";
      },
      //翻页
      handleCurrentChange(updateCurrentPage) {
          this.currentPage = updateCurrentPage;
      },
    },
  }
  </script>
  
  <style lang="scss" scoped>
  .search{
    margin-top:50px;
    .search_t{
        font-size: 14px;
        font-weight: 600;
        color: #21212B;
        line-height: 16px;
        margin-bottom:10px;
    }
    .search_btn{
        width: 130px;
        height: 38px;
        border-radius: 8px;
        border: 1px solid #158869;
        font-size: 16px;
        color: #158869;
        line-height: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
}
.action_btn_r{
  font-size: 16px;
  font-family: ArialMT;
  color: #158869;
  cursor: pointer;
}
.display_flex{
    display: flex;
    justify-content: flex-end;
    align-items: center;
}
.wd_90{
    width: 90px !important;
}
.mg_t_50{
  margin-top:50px;
}
::v-deep .tabs{
    .el-tabs__item{
      font-size: 24px;
      font-family: ArialMT;
      height: 45px;
      font-weight: 600;
      color: #1E1E1E;
      line-height: 28px;
    }
    .el-tabs__item.is-active{
      color: #158869;
      
    }
    .el-tabs__active-bar{
      height: 4px;
      background-color: #158869;
    }
  }
  </style>
  